import React from 'react';

import {RichTextDisplay} from '../../rich-text-display/rich-text-display';

type Props = {
    text: string;
    size?: 'normal' | 'small';
    centerContent?: boolean;
    placeholderText?: string;
};

export function QuoteRichTextDisplay(props: Props) {
    return (
        <div className='full-height full-width pad-16 border-box text-wrap'>
            <RichTextDisplay
                html={props.text}
                size={props.size}
                centerContent={props.centerContent}
                placeholderText={props.placeholderText}
            />
        </div>
    );
}
